import React, { useState, useEffect, useRef } from 'react';
import { DIAL_CODES, getDialEntry, parsePhoneValue } from '../../utils/dialCodes';

const PhoneDialCodeSelector = ({ value, onChange, dialCountryCode, onDialCountryCodeChange }) => {
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef(null);

  const selected = getDialEntry(dialCountryCode);
  const digits = parsePhoneValue(value, selected);

  // Close dropdown on outside click
  useEffect(() => {
    const handleClick = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    if (open) document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, [open]);

  const handleSelectCode = (entry) => {
    setOpen(false);
    if (onDialCountryCodeChange) onDialCountryCodeChange(entry.code);
    onChange(entry.dialCode + digits);
  };

  const handleDigitsChange = (e) => {
    const raw = e.target.value.replace(/[^\d\s\-()]/g, '');
    onChange(selected.dialCode + raw);
  };

  return (
    <div className="sf-phone-dial" ref={dropdownRef}>
      {/* Country code selector */}
      <button
        type="button"
        className="sf-phone-dial__selector"
        onClick={() => setOpen(prev => !prev)}
      >
        <span className="sf-phone-dial__flag">{selected.flag}</span>
        <span className="sf-phone-dial__code">{selected.code}</span>
        <span className="sf-phone-dial__dialcode">{selected.dialCode}</span>
        <span className="sf-phone-dial__arrow">{open ? '▲' : '▼'}</span>
      </button>

      {/* Dropdown list */}
      {open && (
        <div className="sf-phone-dial__dropdown">
          {DIAL_CODES.map(entry => (
            <button
              key={entry.code}
              type="button"
              className={`sf-phone-dial__option ${selected.code === entry.code ? 'sf-phone-dial__option--active' : ''}`}
              onClick={() => handleSelectCode(entry)}
            >
              <span className="sf-phone-dial__flag">{entry.flag}</span>
              <span className="sf-phone-dial__option-name">{entry.name}</span>
              <span className="sf-phone-dial__dialcode">{entry.dialCode}</span>
            </button>
          ))}
        </div>
      )}

      {/* Phone number input */}
      <input
        type="tel"
        className="sf-phone-dial__input"
        placeholder="Número de teléfono"
        value={digits}
        onChange={handleDigitsChange}
        inputMode="tel"
      />
    </div>
  );
};

export default PhoneDialCodeSelector;
